import {
  deleteCookie,
  getCookie,
  setCookie,
  syncAppWithToken,
} from '../../../helpers/props'
import { initialBootstrapData } from '../reducer/auth'
import { MainAction } from './models'
import { GET_BOOTSTRAP_DATA, GET_COUNTRIES, GET_TOKEN } from './types'
import { getDefaultBookmark } from './bookmarkActions'
import { HandleCacheData } from '@/helpers/handleCacheData'
import { AxiosError } from 'axios'
import intrack from '@/helpers/intrack'

export const getCountries: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      dispatch({
        type: GET_COUNTRIES,
        data: [],
        loading: true,
      })
      const res = await api.get('/auth/countries', {
        perpage: '6',
      })
      dispatch({
        type: GET_COUNTRIES,
        data: res.data.data,
        loading: false,
      })
    } catch (err) {
      dispatch({
        loading: false,
        type: GET_COUNTRIES,
        data: [],
      })
    }
  }
// check is user exist
export const enterMobile: MainAction<[string, any, boolean]> =
  (mobile: string, callback: any, isHost) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })
    try {
      const res = await api.post('/auth/check-mobile', {
        mobile,
        country_code: '+98',
      })
      callback({
        status: true,
        message: null,
        data: {
          user_status: res?.data?.data?.status ?? 'login',
          token: res?.data?.data?.['verification-token'],
        },
      })
    } catch (err) {
      if ((err as AxiosError)?.response) {
        if ((err as AxiosError).response?.status === 422) {
          callback({
            status: false,
            errorCode: 422,
            message:
              'قالب شماره همراه واردشده صحیح نیست. مثال صحیح: ۰۹۱۲۱۲۳۴۵۶۷',
          })
        }
        if ((err as AxiosError).response?.status === 429) {
          callback({
            status: false,
            errorCode: 429,
            message: 'لطفا لحظاتی دیگر مجدد تلاش کنید.',
          })
        } else
          callback({
            status: false,
            message:
              'ارتباط با سرور برقرار نشد. لطفا لحظاتی دیگر مجدد تلاش کنید.',
          })
      } else {
        callback({
          status: false,
          errorCode: 'net',
          message: 'راه‌های ارتباطی شما قطع شده است.',
        })
      }
      // err
    }
  }

// entering i forget my password
export const forgetPassMobile: MainAction<[string, any]> =
  (mobile: string, callback: any) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      await api.post(`/auth/password/forget?mobile=${mobile}`, {
        mobile,
        country_code: '+98',
      })
      callback({
        status: true,
        message: '',
      })
    } catch (err: any) {
      if (err?.response) {
        if (err.response.status >= 400 && err.response.status < 500) {
          callback({
            status: false,
            message: 'خطای سرور، مجدداً تلاش کنید',
          })
        }
      }
    }
  }
// login with password
export const loginWithPass: MainAction<
  [string, string, boolean, any, boolean]
> =
  (
    mobile: string,
    password: string,
    isRemember: boolean,
    callback: any,
    isHost,
  ) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })
    try {
      const res = await api.post('/auth/login', {
        mobile,
        password,
        is_remember: isRemember,
      })
      if (res.data.data.access_token) {
        syncAppWithToken(dispatch, false)
        callback({ status: true, message: '' })
      } else {
        callback({
          status: false,
          message: 'خطای سرور، مجدداً تلاش کنید',
        })
      }
    } catch (err: any) {
      if (err?.response) {
        if (err?.response?.status === 422) {
          callback({
            status: false,
            message: 'نام کاربری یا رمز عبور اشتباه است!',
          })
        } else if (err.response.status >= 400 && err.response.status < 500) {
          callback({ status: false, message: 'خطای سرور، مجدداً تلاش کنید' })
        }
      } else {
        callback({
          status: false,
          errorCode: 'net',
          message: 'راه‌های ارتباطی شما قطع شده است.',
        })
      }
      // err
    }
  }

type callbackArgs = { status: 'SUCCESS' | 'ERROR'; message: string }

// login with verify code
export const loginOtp: MainAction<[string, (args: callbackArgs) => void]> =
  (mobile, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })
    try {
      await api.post('/auth/login-otp', {
        mobile,
        country_code: '+98',
      })
      callback({ status: 'SUCCESS', message: '' })
    } catch (err) {
      if ((err as AxiosError).response) {
        if ((err as AxiosError).response?.status === 429) {
          callback({
            status: 'ERROR',
            message: 'لطفا لحظاتی دیگر مجدد تلاش کنید.',
          })
        } else
          callback({
            status: 'ERROR',
            message:
              'ارتباط با سرور برقرار نشد. لطفا لحظاتی دیگر مجدد تلاش کنید.',
          })
      } else {
        callback({
          status: 'ERROR',
          message: 'راه‌های ارتباطی شما قطع شده است.',
        })
      }
    }
  }

// submitting verify code for login
export const verifyOtp: MainAction<
  [
    { mobile: string; code: string },
    (args: callbackArgs & { type?: 'register' }) => void,
  ]
> =
  ({ mobile, code }, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })
    try {
      const res = await api.post('/auth/verify-otp', {
        mobile,
        code,
        country_code: '+98',
      })
      if (res?.data?.data?.status === 'register') {
        callback({ status: 'SUCCESS', message: '', type: 'register' })
      } else if (res?.status === 200) {
        syncAppWithToken(dispatch, false)
        callback({ status: 'SUCCESS', message: '' })
      } else {
        callback({
          status: 'ERROR',
          message: 'خطای سرور، مجدداً تلاش کنید',
        })
      }
    } catch (err: any) {
      if (err?.response) {
        if (err.response?.status === 422) {
          callback({
            status: 'ERROR',
            message: 'کد واردشده صحیح نیست. لطفا مجدد تلاش کنید.',
          })

          return
        } else if (err.response.status === 429) {
          callback({
            status: 'ERROR',
            message: 'لطفا لحظاتی دیگر مجدد تلاش کنید.',
          })
        } else if (err.response.status >= 400 && err.response.status < 500) {
          callback({
            status: 'ERROR',
            message:
              'ارتباط با سرور برقرار نشد. لطفا لحظاتی دیگر مجدد تلاش کنید.',
          })
        }
      } else {
        callback({
          status: 'ERROR',
          message: 'راه‌های ارتباطی شما قطع شده است.',
        })
      }
    }
  }

// entering verify code for password forgetting
export const enterForgetPassCode: MainAction<[string, any]> =
  (code: string, callback: any) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      await api.post('/auth/enter-forget-password-code', {
        code,
      })
      callback(false)
    } catch (err: any) {
      if (err?.response) {
        if (err.response.status >= 400 && err.response.status < 500) {
          callback('خطای سرور، مجدداً تلاش کنید')
        }
      } else {
        callback({
          status: false,
          errorCode: 'net',
          message: 'راه‌های ارتباطی شما قطع شده است.',
        })
      }
    }
  }

// completing profile
export const completeProfile: MainAction<
  [
    { name: string; family: string; mobile: string; code: number },
    (args: callbackArgs) => void,
  ]
> =
  ({ name, family, mobile, code }, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      await api.post('/auth/complete-profile', {
        name,
        family,
        code,
        mobile,
      })
      syncAppWithToken(dispatch, false)
      callback({ status: 'SUCCESS', message: '' })
    } catch (err: any) {
      if (err?.response) {
        if (
          err.response.status === 422 &&
          err.response?.meta?.messages?.length &&
          err.response.meta.messages[0].invite_code
        ) {
          callback({
            status: 'ERROR',
            message: err.response.meta.messages[0].invite_code,
            // type: 'inviter',
          })
        } else if (err.response.status === 429) {
          callback({
            status: 'ERROR',
            message: 'لطفا لحظاتی دیگر مجدد تلاش کنید.',
          })
        } else if (err.response.status >= 400 && err.response.status < 500) {
          callback({
            status: 'ERROR',
            message: 'خطای سرور، مجدداً تلاش کنید',
          })
        }
      } else {
        callback({
          status: 'ERROR',
          message: 'راه‌های ارتباطی شما قطع شده است.',
        })
      }
    }
  }

// submitting new password:
export const newPassword: MainAction<[string, number, any]> =
  (password: string, code: number, callback: any) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      await api.post('/auth/new-password', {
        password,
        code,
      })
      callback(false)
    } catch (err: any) {
      if (err?.response) {
        if (err.response.status >= 400 && err.response.status < 500) {
          callback('خطای سرور، مجدداً تلاش کنید')
        }
      }
    }
  }

// submitting verify code for signup
export const enterActivationCode: MainAction<[string, string, any]> =
  (code: string, verification, callback: any) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      await api.post(
        '/auth/enter-activation-code',
        {
          code,
        },
        {
          headers: { 'verification-token': verification },
        },
      )
      callback({ status: true, message: '' })
    } catch (err: any) {
      if (err?.response) {
        if (err.response?.status === 422) {
          callback({ status: true, message: 'کد منقضی شده یا اشتباه است!' })
          return
        } else if (err.response.status === 404) {
          callback({ status: false, message: 'کد وارد شده اشتباه است!' })
        } else if (err.response.status === 429) {
          callback({
            status: false,
            message: 'لطفا لحظاتی دیگر مجدد تلاش کنید.',
          })
        } else if (err.response.status >= 400 && err.response.status < 500) {
          callback({ status: false, message: 'خطای سرور، مجدداً تلاش کنید!' })
        }
      } else {
        callback({
          status: false,
          errorCode: 'net',
          message: 'راه‌های ارتباطی شما قطع شده است.',
        })
      }
    }
  }

// Logout
export const logout: MainAction =
  () =>
  (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    // if (getCookie('logged-in')) {
    const clearLoginData = () => {
      deleteCookie('verification-token')
      deleteCookie('access-token')
      deleteCookie('refresh-token')
      deleteCookie('shab_ir_session')
      deleteCookie('fb-token')
      deleteCookie('logged-in')
      new HandleCacheData().removeAllCache()
      sessionStorage.removeItem('calendar-date')
      dispatch({
        type: GET_TOKEN,
        key: '',
      })
      setTimeout(() => {
        window.location.reload()
      }, 0)
    }
    const firebaseToken = getCookie('fb-token')

    api
      .post(
        '/auth/logout',
        firebaseToken && {
          push_notification_token: firebaseToken,
        },
      )
      .then(() => {
        clearLoginData()
      })
      .catch(err => {
        clearLoginData()
      })
      .finally(() => {
        intrack.user.logout()
      })
    // }
  }
// }

export const fetchBootstrapData: MainAction<[((data: any) => void)?]> =
  callback =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })

    dispatch({
      type: GET_BOOTSTRAP_DATA,
      data: initialBootstrapData.data,
      loading: true,
    })

    try {
      const res = await api.get('/bootstrap')

      dispatch({
        type: GET_BOOTSTRAP_DATA,
        data: res.data,
        loading: false,
      })

      dispatch(getDefaultBookmark(res?.data?.bookmark_ids))
      if (res?.data?.user_info?.uid) {
        setCookie('logged-in', 'true')

        dispatch({
          type: GET_TOKEN,
          key: 'true',
        })
      } else {
        dispatch({
          type: GET_TOKEN,
          key: '',
        })
        deleteCookie('logged-in')
      }
      callback && callback(res?.data)
    } catch (err) {
      // Handle Err
      dispatch({
        type: GET_BOOTSTRAP_DATA,
        data: null,
        loading: false,
      })
      callback && callback(err)
    }
  }
export const autoLogin: MainAction<[string, any]> =
  (token, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })
    try {
      const res = await api.post('/auth/login-by-link', { token })
      if (res.data.meta.status === 200) {
        callback({
          status: 200,
          message: '',
        })
      }
    } catch (err) {
      const error = err as AxiosError
      if (error?.response?.status === 401) {
        callback({
          status: 401,
        })
      }
    }
  }

export const authCallback: MainAction<[any, any]> =
  (data, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })
    try {
      const res = await api.post('/auth/external-app', { ...data })
      callback({
        data: res?.data,
        status: res?.data?.meta?.status,
        message: res?.data?.meta?.messages?.[0],
      })
    } catch (err) {
      const error = err as AxiosError
      callback({
        data: null,
        status: error?.response?.data?.meta?.status,
        message: error?.response?.data?.meta?.messages?.[0],
      })
    }
  }

export const completeExternalProfile: MainAction<
  [{ name: string; family: string }, (args: callbackArgs) => void]
> =
  ({ name, family }, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    try {
      await api.post('auth/external-complete-profile', {
        name,
        family,
      })
      callback({ status: 'SUCCESS', message: '' })
    } catch (err: any) {
      callback({
        status: 'ERROR',
        message:
          err?.response?.meta?.messages[0] ||
          err?.message ||
          'متاسفانه مشکلی پیش آمده است لطفا مجددا امتحان کنید.',
      })
    }
  }

export const requestDeleteOtp: MainAction<[any]> =
  callback =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })
    try {
      const res = await api.post('/profile/send-delete-account-otp')
      callback({
        status: 'success',
        verificationToken: res?.headers?.['verification-token'],
      })
    } catch (err) {
      const error = err as AxiosError
      callback({
        status: 'error',
      })
    }
  }

export const verifyDeleteOtp: MainAction<[string, string, any]> =
  (verificationToken, otp, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
      headers: {
        ['verification-token']: verificationToken,
      },
    })
    try {
      const res = await api.post('/profile/delete-account', { token: otp })
      callback({
        status: 'success',
      })
    } catch (err) {
      const error = err as AxiosError
      callback({
        status: 'error',
        message: error?.response?.data?.meta?.messages?.[0],
      })
    }
  }
